import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../redux/report/actions'

// ui
import { Tabs } from 'antd'

// subcomponent
import HistoryReport from './HistoryReport'
import ListInputReports from './ListInputReports'
import ModalReportInfo from './ModalReportInfo'

const { TabPane } = Tabs

class ReportMangement extends Component {
    componentDidMount() {
        this.props.setInitState()
        if (this.props.match) {
            console.log(
                'this.props.match.params.id',
                this.props.match.params.id
            )
            this.props.getCurrentReport(this.props.match.params.id)
        }
    }

    render() {
        const { height } = this.props
        return (
            <div className="ReportMangement">
                <div className="MainCard" style={{ minHeight: height - 100 }}>
                    <Tabs
                        defaultActiveKey="1"
                        style={{ height: '100%' }}
                        tabBarStyle={{ color: 'white' }}
                    >
                        <TabPane tab="Danh sách báo cáo" key="1">
                            <ListInputReports />
                        </TabPane>
                        <TabPane tab="Lịch sử các báo cáo đã lập" key="2">
                            <HistoryReport />
                        </TabPane>
                    </Tabs>

                    <ModalReportInfo />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.app,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setInitState: () => {
            dispatch(ReportActions.action.setInitState())
        },
        getCurrentReport: id => {
            dispatch(ReportActions.action.getReportById(id))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportMangement)
